export default function ContactSection() {
  return (
    <section id="contact" className="relative py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">联系我们</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">有任何问题或建议？欢迎与我们取得联系</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/50">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/15">
                  <i className="ri-mail-line text-lg text-primary-400"></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-200 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-500">contact@dashixiong.tv</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl bg-accent-500/15">
                  <i className="ri-wechat-line text-lg text-accent-400"></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-200 mb-1">微信公众号</h3>
                  <p className="text-sm text-foreground-500">大师兄影视官方</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-500/15">
                  <i className="ri-weibo-line text-lg text-secondary-400"></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-200 mb-1">新浪微博</h3>
                  <p className="text-sm text-foreground-500">@大师兄影视官方</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/15">
                  <i className="ri-feedback-line text-lg text-primary-400"></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-200 mb-1">内容投稿</h3>
                  <p className="text-sm text-foreground-500">submit@dashixiong.tv</p>
                </div>
              </div>
            </div>
            <div className="mt-8 pt-6 border-t border-background-200/40 text-center">
              <p className="text-xs text-foreground-600">
                客服工作时间：每日 9:00 - 22:00 · 通常 2 小时内回复
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}